import { LoginModel } from "../../models/Login";
import Helpers from "../../utilities/Helpers.ts";
import api, { xspocApiInstance } from "../api.ts";
import TokenService from "./token.service.ts";
import { v4 as uuidv4 } from "uuid";
import { UserRolesResponse } from "../../models/UserRoles.ts";
import { getAllyConnectURL } from "../../utilities/baseUrlutility.tsx";

const logout = async (appPath: string, loginURL: string | null) => {
  const host =
    process.env.REACT_APP_DEVELOPMENT_WEB_APP_BASE_URL || window.location.host;

  if (!loginURL) {
    Helpers.ConsoleLog("Login URL is not available", "error");
    return "failed";
  }

  const allyConnectURL = getAllyConnectURL(loginURL);
  const logoutRedirectURL = `${allyConnectURL}/Account/LogOut?app=${host}${appPath}/login`;
  const isOnboardingApp = window.location.pathname.includes('allyonboarding');
      
  try {
    // If there's no user, redirect immediately
    if (!TokenService.getUser()) {
      console.log('Auth Service: session expired instance, ' + isOnboardingApp);
      const redirectURL = isOnboardingApp
        ? `${loginURL}/Account/Login?app=${appPath}/login`
        : logoutRedirectURL;
      window.location.assign(redirectURL);
      
      return;
    }

    const response = await xspocApiInstance.get("Logout");

    if (response?.status === 200) {
      TokenService.removeUser();
      console.log('Auth Service: session expired instance 2, ' + isOnboardingApp);
      const redirectURL = isOnboardingApp
        ? `${loginURL}/Account/Login?app=${appPath}/login`
        : logoutRedirectURL;
      window.location.assign(redirectURL);
    } else {
      Helpers.ConsoleLog(
        `Logout API failed with status: ${response?.status}`,
        "error"
      );
    }
  } catch (error) {
    Helpers.ConsoleLog(`Logout request failed: ${error}`, "error");
    window.location.assign(logoutRedirectURL);
    return "failed";
  }
};

const isUserLoggedIn = () => {
  return TokenService.getUser() != null;
};

const login = async (
  appPath: string,
  login: LoginModel,
  isCloud: boolean,
  loginURL: string
) => {
  const uuid = uuidv4();

  if (isCloud === null || isCloud === undefined) {
    return Promise.resolve("failed");
  }

  return await xspocApiInstance
    .post("LoginByRefToken", login.reference, {
      headers: {
        "content-type": "application/json",
        'xspoc-ui-tracking-id': uuid,
      },
    })
    .then(async function (response: any) {
      if (response) {
        const uuid = uuidv4();
        TokenService.addOrUpdateLocalCorrelationId(uuid);
        TokenService.setUser("success");

        return "success";
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      logout(appPath, loginURL);
      return "failed";
    });
};

const refreshTokenFromServer = async (appPath: string, loginURL: string) => {
  try {
    await xspocApiInstance
      .post("RefreshToken")
      .then((response) => {
        if (response.status === 200) {
          TokenService.setUser("success");
          return "success";
        } else {
          return "failed";
        }
      })
      .catch(function (error) {
        Helpers.ConsoleLog(error, "error");
        logout(loginURL, appPath);
        return "failed";
      });
  } catch (error) {
    Helpers.ConsoleLog(error, "error");
    return "failed";
  }
};

// Fetch user roles
const getUserRoles = async (): Promise<string[]> => {
  try {
    const response = await xspocApiInstance.get<UserRolesResponse>(
      "Account/GetUserRoles",
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );

    if (response && response.data) {
      const roles = Object.keys(response.data.values).filter(
        (role) => response.data.values[role]
      );
      return roles;
    } else {
      return [];
    }
  } catch (error) {
    Helpers.ConsoleLog(error, "error");
    return [];
  }
};

const AuthService = {
  logout,
  isUserLoggedIn,
  refreshTokenFromServer,
  login,
  getUserRoles,
};

export default AuthService;
